export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img5-ad0fa606edb9464a6c7076a5cf601bc1.png";